import React from 'react';
import TablePagination from '@material-ui/core/TablePagination';
import PAGINATION_SIZE from 'helpers/globalConstants';
import ToggleButton from 'components/ToggleButton';

export const paginationStyles = {
  paginationTableStyles: {
    border: 0,
    color: '#696F88',
    padding: '0px'
  },
  paginationButtonStyles: {
    border: '1px solid',
    borderRadius: '4px',
    padding: '1px'
  }
};
const ActionComponentDisabled = () => <span />;

const CwFPagination = (
  totalCount,
  pageNumber,
  handlePageChange,
  leftElement = null,
  rowsPerPage = PAGINATION_SIZE,
  toggleButtonEnabled = false,
  setToggleButtonEnabled = undefined
) => {
  const LeftComponent = leftElement;
  const showPaginationArrows = totalCount > rowsPerPage;
  // Plain containers around one real table: the old markup put divs and
  // spans straight into <table> and <tr>, which is invalid HTML. The outer box
  // keeps the table display it had, so the floats inside are still contained.
  return (
    <div
      className={`w-full ${
        setToggleButtonEnabled
          ? 'flex flex-row justify-between items-center'
          : 'table'
      }`}
    >
      {setToggleButtonEnabled && (
        <div className="float-left">
          <div className="flex flex-row items-center">
            <ToggleButton
              key="enabled"
              color="#0071CD"
              name="View planting data"
              big
              defaultChecked={toggleButtonEnabled}
              onChange={e => setToggleButtonEnabled(e.currentTarget.checked)}
            />
            <span className="inline-block pl-2 -mt-2px text-sm">
              View planting data
            </span>
          </div>
        </div>
      )}
      <div className="float-right">
        <table>
          <thead>
            <tr>
              {/* A td centred like the th it replaces: TablePagination renders
                  its own td, so neither cell can sit inside a th. */}
              {LeftComponent ? (
                <td className="font-normal text-center">
                  <LeftComponent />
                </td>
              ) : null}
              <TablePagination
                count={totalCount}
                rowsPerPageOptions={[]}
                rowsPerPage={rowsPerPage}
                page={pageNumber}
                style={paginationStyles.paginationTableStyles}
                backIconButtonProps={{
                  style: {
                    ...paginationStyles.paginationButtonStyles,
                    marginRight: '8px'
                  }
                }}
                nextIconButtonProps={{
                  style: { ...paginationStyles.paginationButtonStyles }
                }}
                onPageChange={(_, page) => {
                  handlePageChange(page);
                }}
                ActionsComponent={
                  showPaginationArrows ? undefined : ActionComponentDisabled
                }
              />
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};

export default CwFPagination;
